module.exports = __webpack_public_path__ + "static/media/d3.abf945c2.png";